import { createAsyncThunk } from "@reduxjs/toolkit";
import { Api } from "../..";
import { CustomAction } from "../../store/customAction";
import {
  API_GET_PROMPT_BY_KEY,
  API_UPDATE_PROMPT_BY_KEY,
} from "../../Apis/ApiEndPoints";
import { IUpdateRequestBody } from "../../models/admin/PromptManagement/PromptManagement";

export const getPromptByKey = createAsyncThunk(
  "prompt/getPromptByKey",
  async (promptKey: string, { dispatch }) => {

    const response = await CustomAction(
      Api.get(`${API_GET_PROMPT_BY_KEY}/${promptKey}`),
      dispatch,
      "prompt/getPromptByKey"
    );
    return response;
  }
);

export const updatePromptByKey = createAsyncThunk(
  "prompt/updatePromptByKey",
  async (requestParams: IUpdateRequestBody, { dispatch }) => {
    const response = await CustomAction(
      Api.put(API_UPDATE_PROMPT_BY_KEY, requestParams),
      dispatch,
      "prompt/updatePromptByKey"
    );
    return response;
  }
);
